import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
  Button,
} from 'reactstrap';
import { callApi } from '../../../utils';
import { showError, showInfo } from '../../../actions/notificationActions';

class CreateMerchantFaqModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: '',
      answers: [],
      category: 'Frequently Asked Questions About My Account',
      loading: false,
      answerInput: '',
    };
  }

  setInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleAnswerInput = (e) => {
    this.setState({ answerInput: e.target.value });
  };

  addAnswer = () => {
    const { answerInput, answers } = this.state;
    if (answerInput.trim()) {
      this.setState({
        answers: [...answers, answerInput],
        answerInput: '',
      });
    }
  };

  removeAnswer = (index) => {
    const { answers } = this.state;
    this.setState({
      answers: answers.filter((_, i) => i !== index),
    });
  };

  createFaq = (e) => {
    e.preventDefault();

    if (this.state.loading) return;

    const { question, answers } = this.state;

    if (!question.trim()) {
      this.props.dispatch(showError('Question is required'));
      return;
    }

    if (answers.length === 0) {
      this.props.dispatch(showError('At least one answer is required'));
      return;
    }

    const prompt = `Are you sure you want to create this FAQ?`;

    if (!window.confirm(prompt)) return;

    this.setState({ loading: true });

    callApi(
      '/merchants/faq',
      {
        question: this.state.question,
        answers: this.state.answers,
        category: this.state.category,
      },
      'post'
    )
      .then((res) => {
        this.props.close();
        this.props.dispatch(showInfo('FAQ created successfully'));
        this.props.refreshFaq();
      })
      .catch((err) => {
        this.props.dispatch(showError(err.message || 'Failed to create FAQ'));
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { question, answers, category, loading, answerInput } = this.state;

    return (
      <Modal
        size="lg"
        isOpen={this.props.open}
        toggle={this.props.close}
        backdrop="static"
      >
        <ModalHeader toggle={this.props.close}>Create New FAQ</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <FormGroup>
                <Label>Question *</Label>
                <Input
                  onChange={this.setInput}
                  value={question}
                  name="question"
                  placeholder="Enter question"
                  type="textarea"
                  required
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col>
              <FormGroup>
                <Label>Category</Label>
                <Input
                  onChange={this.setInput}
                  value={category}
                  name="category"
                  type="text"
                ></Input>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col>
              <FormGroup>
                <Label>Add Answer *</Label>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <Input
                    onChange={this.handleAnswerInput}
                    value={answerInput}
                    placeholder="Type an answer"
                    type="textarea"
                    style={{ flex: 1 }}
                  />
                  <Button
                    color="info"
                    onClick={this.addAnswer}
                    style={{ height: 'fit-content', marginTop: '5px' }}
                  >
                    Add
                  </Button>
                </div>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col>
              <FormGroup>
                <Label>Answers ({answers.length})</Label>
                <div
                  style={{
                    maxHeight: '250px',
                    overflowY: 'auto',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    padding: '10px',
                    minHeight: '100px',
                  }}
                >
                  {answers.length > 0 ? (
                    answers.map((answer, index) => (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '10px',
                          marginBottom: '8px',
                          background: '#f5f5f5',
                          borderRadius: '4px',
                          border: '1px solid #e0e0e0',
                        }}
                      >
                        <span style={{ flex: 1, wordBreak: 'break-word' }}>
                          {answer}
                        </span>
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => this.removeAnswer(index)}
                          style={{ marginLeft: '10px' }}
                        >
                          Remove
                        </Button>
                      </div>
                    ))
                  ) : (
                    <p style={{ color: '#999', textAlign: 'center' }}>
                      No answers added yet
                    </p>
                  )}
                </div>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.close}>
            Cancel
          </Button>
          <Button color="primary" onClick={this.createFaq} disabled={loading}>
            {loading ? 'Creating...' : 'Create FAQ'}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default connect()(CreateMerchantFaqModal);
